import React from "react";
import {Button, Col, Divider, Form, Input, Row, Switch} from "antd";


const tailLayout = {
    /*wrapperCol: {
        offset: 0,
        span: 12,
    },*/
    labelCol: {span: 3}
};

export default function () {
    const [form] = Form.useForm();
    const onFinish = () => {

    }
    return (
        <Form
            form={form}
            name="material_detail"
            labelCol={{span: 6}}
            onFinish={onFinish}
        >

            <Divider orientation="left" plain>基本信息</Divider>

            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="customerCode"
                        label="供应商编码"
                    >
                        <Input placeholder="供应商编码"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerName"
                        label="供应商名称"
                    >
                        <Input placeholder="供应商名称"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerType"
                        label="供应商类型"
                    >
                        <Input placeholder="供应商类型"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerLevel"
                        label="联系地址"
                    >
                        <Input placeholder="联系地址"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="contact"
                        label="联系人"
                    >
                        <Input placeholder="联系人"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="contactPhone"
                        label="联系电话"
                    >
                        <Input placeholder="联系电话"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="telephone"
                        label="办公电话"
                    >
                        <Input placeholder="办公电话"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="email"
                        label="电子邮箱"
                    >
                        <Input placeholder="电子邮箱"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="contact2"
                        label="联系人2"
                    >
                        <Input placeholder="联系人2"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="contactPhone2"
                        label="联系电话"
                    >
                        <Input placeholder="联系电话"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="fax"
                        label="传真号码"
                    >
                        <Input placeholder="传真号码"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="website"
                        label="公司网址"
                    >
                        <Input placeholder="公司网址"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="website"
                        label="联系人3"
                    >
                        <Input placeholder="联系人3"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="website"
                        label="联系电话"
                    >
                        <Input placeholder="联系电话"/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="desc"
                        label="备注"
                        {...tailLayout}
                    >
                        <Input placeholder="备注"/>
                    </Form.Item>
                </Col>
            </Row>

            <Divider orientation="left" plain>开票信息</Divider>

            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="customerCode"
                        label="发票抬头"
                    >
                        <Input placeholder="发票抬头"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerName"
                        label="营业执照"
                    >
                        <Input placeholder="营业执照"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerType"
                        label="开户银行"
                    >
                        <Input placeholder="开户银行"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerLevel"
                        label="银行账号"
                    >
                        <Input placeholder="银行账号"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="contact"
                        label="邮寄地址"
                    >
                        <Input placeholder="邮寄地址"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="contactPhone"
                        label="公司法人"
                    >
                        <Input placeholder="公司法人"/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="telephone"
                        label="经营范围"
                        {...tailLayout}
                    >
                        <Input placeholder="经营范围"/>
                    </Form.Item>
                </Col>
            </Row>

            <Divider orientation="left" plain>其他信息</Divider>

            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="customerCode"
                        label="创建人"
                    >
                        <Input placeholder="创建人"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerName"
                        label="创建时间"
                    >
                        <Input placeholder="创建时间"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerType"
                        label="修改人"
                    >
                        <Input placeholder="修改人"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerLevel"
                        label="修改时间"
                    >
                        <Input placeholder="修改时间"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="status"
                        label="是否启用"
                    >
                        <Switch defaultChecked checked={true} size="default"/>
                    </Form.Item>
                </Col>
                <Col span={18}>
                </Col>
            </Row>
            <Row>
                <Col
                    span={24}
                    style={{
                        textAlign: 'center',
                    }}
                >
                    <Button type="primary" htmlType="submit">
                        确定
                    </Button>
                    <Button
                        style={{
                            margin: '0 8px',
                        }}
                        onClick={() => {
                            form.resetFields();
                        }}
                    >
                        重置
                    </Button>

                </Col>
            </Row>
        </Form>
    )
}